/**
 * Time: 2020-07-14 15:43:44
 * Author: zyl
 * Description: 图片编辑器 插入文字
 * 依赖： jquery,cropper
*/

(function (win) {

    'use strict';

    /*
     功能： 文本插入对象
     参数：
     option.parent：容器元素，html元素
     option.url：图片url
     */
    var TextEdit = function (option) {

        var self = this;

        self.dataURL = [];
        self.obj = $(TextEdit.template)[0];
        self.obj.obj = self.obj;
        self.obj.$obj = self.$obj = $(self.obj);
        self.obj.parent = self.parent = option.parent || $('body')[0];
        self.obj.$parent = self.$parent = $(self.parent);
        self.obj.$canvas = self.$canvas = option.$canvas;
        self.obj.textId = 'text_' + new Date().getTime();
        self.obj.self = self;
        self.init(self.obj);

    };

    TextEdit.prototype = {

        /*
         功能： 初始化TextEdit对象
         参数：
         obj： 作用对象
         */
        init: function (obj) {

            var t = this,
                obj = obj || t.obj,
                textArea = $(obj).find('textarea')[0],
                $point = $(obj).find('.point');

            obj.$parent.append(obj.$obj);
            $(obj).find('textarea').attr('id', obj.textId);
            obj._fnStart = BindAsEventListener(obj, t.Start);
            obj._fnMove = BindAsEventListener(obj, t.Move);
            obj._fnStop = Bind(obj, t.Stop);
            addEventHandler(textArea, 'mousedown', obj._fnStart);
            $point.each(function (i) {
                var point = this;
                point.obj = obj;
                point.objParent = obj.parent;
                new Point(point);
            });
            // t.initText();
        },
        setSize: function (size) {
            var t = this,
                obj = t.obj;

            $('#' + obj.textId).css({
                'font-size': size + 'px',
                // "line-height": size + "px"
            });
        },
        setFamily: function (family) {
            var t = this,
                obj = t.obj;

            $('#' + obj.textId).css({
                'font-family': family,
            });
        },
        setItalic: function (state) {
            var t = this,
                obj = t.obj;

            $('#' + obj.textId).css({
                'font-style': state ? 'italic' : 'normal'
            });
        },
        setBold: function (state) {
            var t = this,
                obj = t.obj;

            $('#' + obj.textId).css({
                'font-weight': state ? 'bold' : 'normal'
            });
        },
        setUnderLine: function (state) {
            var t = this,
                obj = t.obj;

            $('#' + obj.textId).css({
                'text-decoration': state ? 'underline' : 'none'
            });
        },
        setColor: function (color) {
            var t = this,
                obj = t.obj;

            $('#' + obj.textId).css({
                'color': color
            });
        },
        initText: function (font, pixel) {
            var t = this,
                obj = t.obj;

            $('#' + obj.textId).css({
                'font-family': font || 'SimSun',
                'font-size': pixel ? pixel + 'px' : '24px',
            });
        },
        lineOffsetXAY: function (text, pixel) {
            var t = this,
                obj = t.obj,
                $test = $("<div style='display: inline-block;position: fixed; top: -1000px;left: -1000px;line-height: normal;'></div>"),
                ret = {};

            $test.css('font-size', pixel + 'px');
            $test.html(text);
            $('body').append($test);
            ret = {
                x: $test.width(),
                y: $test.height()
            };
            $test.remove();
            return ret;
        },
        getText: function () {
            var t = this,
                obj = t.obj;

            return $('#' + obj.textId).val().split('\n');
        },
        getTextLeft: function () {
            var t = this,
                obj = t.obj;

            return obj.offsetLeft;
        },
        getTextTop: function () {
            var t = this,
                obj = t.obj;

            return obj.offsetTop;
        },
        Start: function (e) {

            var obj = this.obj,
                parent = this.parent;

            obj._x = e.pageX - obj.offsetLeft;
            obj._y = e.pageY - obj.offsetTop;
            obj.maxLeft = parent.offsetWidth - obj.offsetWidth;
            obj.maxTop = parent.offsetHeight - obj.offsetHeight;
            addEventHandler(document, 'mousemove', obj._fnMove);
            addEventHandler(document, 'mouseup', obj._fnStop);

        },
        Move: function (e) {

            var obj = this.obj,
                left = e.pageX - obj._x,
                top = e.pageY - obj._y;

            if (left < 0) {left = 0;} else if (left > this.maxLeft) {left = obj.maxLeft;}
            if (top < 0) {top = 0;} else if (top > this.maxTop) {top = obj.maxTop;}
            $(obj).css({
                left: left + 'px',
                top: top + 'px'
            });

        },
        Stop: function (e) {

            var obj = this.obj;

            removeEventHandler(document, 'mousemove', obj._fnMove);
            removeEventHandler(document, 'mouseup', obj._fnStop);
            obj.$parent.removeClass('box-move');

        }
    };

    TextEdit.template = (
        "<div class='imgEditorCanvas-text-edit'>" +
        '<textarea></textarea>' +
        "<span class='point point-nw' data-action='nw'></span>" +
        "<span class='point point-n' data-action='n'></span>" +
        "<span class='point point-ne' data-action='ne'></span>" +
        "<span class='point point-e' data-action='e'></span>" +
        "<span class='point point-se' data-action='se'></span>" +
        "<span class='point point-s' data-action='s'></span>" +
        "<span class='point point-sw' data-action='sw'></span>" +
        "<span class='point point-w' data-action='w'></span>" +
        '</div>'
    );

    /*
     功能: 跟点拖动相关事件
     */
    var Point = function (point) {

        var self = this;

        self.point = point;
        self.point.point = self.point;
        self.point.$point = self.$point = $(self.point);
        self.point.self = self;
        self.init(self.point);

    };

    Point.prototype = {

        /*
         功能： 初始化Point对象
         参数：
         point： 作用对象
         */
        init: function (point) {

            var t = this,
                point = point || t.point;

            point.action = $(point).data('action');
            point._fnStart = BindAsEventListener(point, t.Start);
            point._fnMove = BindAsEventListener(point, t.Move);
            point._fnStop = Bind(point, t.Stop);
            addEventHandler(point, 'mousedown', point._fnStart);
            addEventHandler(point, 'pointerdown', point._fnStart);
        },
        Start: function (e) {

            var point = this.point,
                obj = point.obj,
                objParent = point.objParent;

            e.stopPropagation();
            point.beginX = e.pageX;
            point.beginY = e.pageY;
            point.maxWidth = objParent.offsetWidth - obj.offsetLeft;
            point.maxHeight = objParent.offsetHeight - obj.offsetTop;
            point.maxLeft = objParent.offsetWidth - obj.offsetWidth;
            point.maxTop = objParent.offsetHeight - obj.offsetHeight;
            addEventHandler(document, 'mousemove', point._fnMove);
            addEventHandler(document, 'mouseup', point._fnStop);

        },
        Move: function (e) {

            var point = this.point,
                obj = point.obj,
                objParent = point.objParent,
                differWidth, defferHeight,
                width, height, left, top,
                action = point.action;

            e.stopPropagation();
            switch (action) {
                case 'nw':
                    // 西北
                    point.maxWidth = obj.offsetWidth + obj.offsetLeft;
                    point.maxHeight = obj.offsetHeight + obj.offsetTop;
                    differWidth = point.beginX - e.pageX;
                    defferHeight = point.beginY - e.pageY;
                    width = parseInt(getStyle(obj, 'width')) + differWidth;
                    height = parseInt(getStyle(obj, 'height')) + defferHeight;
                    top = parseInt(getStyle(obj, 'top')) - defferHeight;
                    left = parseInt(getStyle(obj, 'left')) - differWidth;
                    if (width < 10) {width = 10;} else if (width > point.maxWidth) {width = point.maxWidth;}
                    if (height < 10) {height = 10;} else if (height > point.maxHeight) {height = point.maxHeight;}
                    if (left < 0) {left = 0;} else if (left > point.maxLeft) {left = point.maxLeft;}
                    if (top < 0) {top = 0;} else if (top > point.maxTop) {top = point.maxTop;}
                    $(obj).css({
                        width: width + 'px',
                        height: height + 'px',
                        top: top + 'px',
                        left: left + 'px'
                    });
                    break;
                case 'n':
                    // 北
                    point.maxHeight = obj.offsetHeight + obj.offsetTop;
                    defferHeight = point.beginY - e.pageY;
                    height = parseInt(getStyle(obj, 'height')) + defferHeight;
                    top = parseInt(getStyle(obj, 'top')) - defferHeight;
                    if (height < 10) {height = 10;} else if (height > point.maxHeight) {height = point.maxHeight;}
                    if (top < 0) {top = 0;} else if (top > point.maxTop) {top = point.maxTop;}
                    $(obj).css({
                        height: height + 'px',
                        top: top + 'px'
                    });
                    break;
                case 'ne':
                    // 东北
                    point.maxWidth = objParent.offsetWidth - obj.offsetLeft;
                    point.maxHeight = obj.offsetHeight + obj.offsetTop;
                    differWidth = e.pageX - point.beginX;
                    defferHeight = point.beginY - e.pageY;
                    width = parseInt(getStyle(obj, 'width')) + differWidth;
                    height = parseInt(getStyle(obj, 'height')) + defferHeight;
                    top = parseInt(getStyle(obj, 'top')) - defferHeight;
                    if (width < 10) {width = 10;} else if (width > point.maxWidth) {width = point.maxWidth;}
                    if (height < 10) {height = 10;} else if (height > point.maxHeight) {height = point.maxHeight;}
                    if (top < 0) {top = 0;} else if (top > point.maxTop) {top = point.maxTop;}
                    $(obj).css({
                        width: width + 'px',
                        height: height + 'px',
                        top: top + 'px'
                    });
                    break;
                case 'e':
                    // 东
                    point.maxWidth = objParent.offsetWidth - obj.offsetLeft;
                    differWidth = e.pageX - point.beginX;
                    width = parseInt(getStyle(obj, 'width')) + differWidth;
                    if (width < 10) {width = 10;} else if (width > point.maxWidth) {width = point.maxWidth;}
                    $(obj).css({
                        width: width + 'px'
                    });
                    break;
                case 'se':
                    // 东南
                    point.maxWidth = objParent.offsetWidth - obj.offsetLeft;
                    point.maxHeight = objParent.offsetHeight - obj.offsetTop;
                    differWidth = e.pageX - point.beginX;
                    defferHeight = e.pageY - point.beginY;
                    width = parseInt(getStyle(obj, 'width')) + differWidth;
                    height = parseInt(getStyle(obj, 'height')) + defferHeight;
                    if (width < 10) {width = 10;} else if (width > point.maxWidth) {width = point.maxWidth;}
                    if (height < 10) {height = 10;} else if (height > point.maxHeight) {height = point.maxHeight;}
                    $(obj).css({
                        width: width + 'px',
                        height: height + 'px'
                    });
                    break;
                case 's':
                    // 南
                    point.maxHeight = objParent.offsetHeight - obj.offsetTop;
                    defferHeight = e.pageY - point.beginY;
                    height = parseInt(getStyle(obj, 'height')) + defferHeight;
                    if (height < 10) {height = 10;} else if (height > point.maxHeight) {height = point.maxHeight;}
                    $(obj).css({
                        height: height + 'px'
                    });
                    break;
                case 'sw':
                    // 西南
                    point.maxWidth = obj.offsetWidth + obj.offsetLeft;
                    point.maxHeight = objParent.offsetHeight - obj.offsetTop;
                    differWidth = point.beginX - e.pageX;
                    defferHeight = e.pageY - point.beginY;
                    width = parseInt(getStyle(obj, 'width')) + differWidth;
                    height = parseInt(getStyle(obj, 'height')) + defferHeight;
                    left = parseInt(getStyle(obj, 'left')) - differWidth;
                    if (width < 10) {width = 10;} else if (width > point.maxWidth) {width = point.maxWidth;}
                    if (height < 10) {height = 10;} else if (height > point.maxHeight) {height = point.maxHeight;}
                    if (left < 0) {left = 0;} else if (left > point.maxLeft) {left = point.maxLeft;}
                    $(obj).css({
                        width: width + 'px',
                        height: height + 'px',
                        left: left + 'px'
                    });
                    break;
                case 'w':
                    // 西
                    point.maxWidth = obj.offsetWidth + obj.offsetLeft;
                    differWidth = point.beginX - e.pageX;
                    width = parseInt(getStyle(obj, 'width')) + differWidth;
                    left = parseInt(getStyle(obj, 'left')) - differWidth;
                    if (width < 10) {width = 10;} else if (width > point.maxWidth) {width = point.maxWidth;}
                    if (left < 0) {left = 0;} else if (left > point.maxLeft) {left = point.maxLeft;}
                    $(obj).css({
                        width: width + 'px',
                        left: left + 'px'
                    });
                    break;
                default:
            }
            point.beginX = e.pageX;
            point.beginY = e.pageY;

        },
        Stop: function () {

            var point = this.point;

            removeEventHandler(document, 'mousemove', point._fnMove);
            removeEventHandler(document, 'mouseup', point._fnStop);

        }
    };

    /**
     * [getStyle description]功能： 获取元素的计算样式
     *
     * @param  {[type]}  obj   [obj description]html元素
     * @param  {[type]}  attr   [attr description]css属性
     *
     * @return  {[type]}   [return description]
     */
    function getStyle(obj, attr) {

        if (obj.currentStyle) {
            return obj.currentStyle[attr];
        } else {
            return getComputedStyle(obj, false)[attr];
        }

    }

    /**
     * [addEventHandler description]功能： 给元素添加事件监听器
     *
     * @param  {[type]}  oTarget   [oTarget description]添加事件的html元素
     * @param  {[type]}  sEventType   [sEventType description]事件类型，没有on
     * @param  {[type]}  fnHandler   [fnHandler description]事件处理函数
     *
     * @return  {[type]}   [return description]
     */
    function addEventHandler(oTarget, sEventType, fnHandler) {

        if (oTarget.addEventListener) {
            oTarget.addEventListener(sEventType, fnHandler, false);
        } else if (oTarget.attachEvent) {
            oTarget.attachEvent('on' + sEventType, fnHandler);
        } else {
            oTarget['on' + sEventType] = fnHandler;
        }

    }

    /**
     * [removeEventHandler description]功能： 删除元素事件监听器
     *
     * @param  {[type]}  oTarget   [oTarget description]删除事件监听器的html元素
     * @param  {[type]}  sEventType   [sEventType description]事件类型，没有on
     * @param  {[type]}  fnHandler   [fnHandler description]事件处理函数
     *
     * @return  {[type]}   [return description]
     */
    function removeEventHandler(oTarget, sEventType, fnHandler) {

        if (oTarget.removeEventListener) {
            oTarget.removeEventListener(sEventType, fnHandler, false);
        } else if (oTarget.detachEvent) {
            oTarget.detachEvent('on' + sEventType, fnHandler);
        } else {
            oTarget['on' + sEventType] = null;
        }

    }

    /**
     * [Bind description]功能：改变fun的上下文为object,fun之后的参数做为fun的参数调用，改变fun的上下文
     *
     * @param  {[type]}  object   [object description]
     * @param  {[type]}  fun   [fun description]
     *
     * @return  {[type]}   [return description]
     */
    function Bind(object, fun) {

        var args = Array.prototype.slice.call(arguments).slice(2);
        return function () {
            return fun.apply(object, args);
        };

    }

    /*
     功能：给给object元素绑定事件监听器fun,fun之后的参数做为fun的参数调用,改变fun的上下文
     */
    var BindAsEventListener = function (object, fun) {

        var args = Array.prototype.slice.call(arguments).slice(2);
        return function (event) {
            return fun.apply(object, [event || window.event].concat(args));
        };

    };

    win.TextEdit = TextEdit;

})(window);
